import _window from "@src/libraries/window";
import { isProduction } from '@src/assets/js/utils';
let BUGSNAG;
let BUGSNAG_PROMISE;
export async function getBugsnag() {
    if (!isProduction())
        return;
    const location = _window.location;
    const host = location && location.host;
    if (host && host.startsWith("testing"))
        return;
    if (BUGSNAG)
        return BUGSNAG;
    if (BUGSNAG_PROMISE)
        return BUGSNAG_PROMISE;
    return BUGSNAG_PROMISE = new Promise(async (resolve) => {
        const usersStore = await import('@src/store/users');
        if (1 == usersStore.default.meId)
            return;
        if (52 == usersStore.default.meId)
            return;
        const bugsnagImport = await import('@bugsnag/js');
        BUGSNAG = bugsnagImport.default;
        BUGSNAG && BUGSNAG.start({
            apiKey: "a11cbfdb123a7e3f4629fb9fbd94b15b",
            onError(event) {
                const msg = event.errors && event.errors[0] && event.errors[0].errorMessage;
                if (msg.includes("No available storage method found"))
                    return false;
                return true;
            }
        });
        resolve(BUGSNAG);
    });
}
;
